module.exports = __webpack_public_path__ + "files/cde13a6849afb0ff4f17f715d0d46751.svg";